import { render, staticRenderFns } from "./ivst.vue?vue&type=template&id=1273f1cc&scoped=true"
import script from "./ivst.vue?vue&type=script&lang=js"
export * from "./ivst.vue?vue&type=script&lang=js"
import style0 from "./ivst.vue?vue&type=style&index=0&id=1273f1cc&prod&lang=css"
import style1 from "./ivst.vue?vue&type=style&index=1&id=1273f1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273f1cc",
  null
  
)

export default component.exports